import UserLayout from "../components/UserLayout";
import GalleryMain from "../components/GalleryMain";
const GalleryMainPage = () => {
    return (
        <UserLayout>
            <GalleryMain />
        </UserLayout>
    );
}

export default GalleryMainPage;